import { z } from 'zod';

import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { OptionalStringSchema } from '../common';

export const OptionalBaseEncounterParamsSchema = z.object({
  providerUserId: OptionalStringSchema,
  encounterEhrReferenceValue: OptionalStringSchema,
  encounterId: OptionalStringSchema,
  encounterStartTime: OptionalStringSchema,
  encounterEndPressedTimestamp: OptionalStringSchema,
});

export function OptionalBaseEncounterParamsFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.payload.providerUserId"
        label="Provider User Id"
        helperText="Enter the reference Provider User Id Referral Comment. e.g. `{{encounter.data.providerUserId}}`"
        placeholder="e.g. {{encounter.data.providerUserId}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.encounterEhrReferenceValue"
        label="FIN"
        helperText="Enter the reference to the Encounter Ehr Reference Value. e.g. `{{encounter.data.encounterEhrReferenceValue}}`"
        placeholder="e.g. {{encounter.data.encounterEhrReferenceValue}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.encounterId"
        label="Encounter Id"
        helperText="Enter the Encounter Id. e.g. `{{encounter.data.id}}`"
        placeholder="e.g. {{encounter.data.id}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.encounterStartTime"
        label="Encounter Start Time"
        helperText="Enter the reference Encounter Start Time. e.g. `{{encounter.data.encounterStartTime}}`"
        placeholder="e.g. {{encounter.data.encounterStartTime}}"
      />
      <BlockValueTemplateField
        fieldName="config.payload.encounterEndPressedTimestamp"
        label="Encounter End Pressed Timestamp"
        helperText="Enter the reference to the Encounter End Pressed Timestamp e.g. `{{encounter.data.encounterEndPressedTimestamp}}`"
        placeholder="e.g. {{encounter.data.encounterEndPressedTimestamp}}"
      />
    </>
  );
}
